/* eslint-disable jsx-a11y/img-redundant-alt, import/extensions */
import React from "react";
import PropTypes from "prop-types";
// import { get } from "lodash";

import { addAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, ComScore, DeepBI, Chartbeat, ContentInsights } from "../../integrations";
import { DfpAd } from "../atoms/dfp-ad";

const newTemplates = addAdsToTemplates("home");
function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

export class HomePage extends React.Component {
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    ComScore.registerPageView();
    Chartbeat.registerNonStoryPageView(this.props.pageType, {});
    ContentInsights.registerNonStoryPageView(this.props.config.contentInsightsId, this.props.pageType, {
      collection: this.props.data.collection
    });
    DeepBI.loadScript();
  }

  render() {
    return (
      <div>
        <LazyCollection
          collection={this.props.data.collection}
          collectionTemplates={getAdsWrappedCollectionTemplate}
          lazyAfter={10}
          accentColor={"#2f81cd"}
        />
        <DfpAd className="hidden-mobile" adtype="Roadblock" placement="home" />
        <DfpAd className="hidden-mobile" adtype="Subscription_Lightbox" placement="home" />
        <DfpAd className="hidden-desktop" adtype="Interstitial" placement="home" />
        <DfpAd className="hidden-desktop" adtype="Mobile_lightbox" placement="home" />
        {/* {!get(this.props.config, ["disableAds"]) && (
          <div className="container">
            <div data-crowdynews-widget="Vikatan_trending-2019">
              <script src="//widget.crowdynews.com/Vikatan_trending-2019.js" async />
            </div>
          </div>
        )} */}
      </div>
    );
  }
}

HomePage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
